import { Tooltip } from '@vesyl/ui'
import { Box, Icon, Image, type ImageProps } from '@vesyl/ui/chakra'
import { LuCameraOff } from 'react-icons/lu'

export function ProductImage(
  props: Omit<ImageProps, 'src'> & { src?: string | null; tooltip?: string },
) {
  const { src, alt, tooltip, ...rest } = props

  let markup = null

  if (!src) {
    markup = (
      <Box
        boxSize={10}
        minW={10}
        rounded="lg"
        {...rest}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg={'bg.muted'}
      >
        <Icon as={LuCameraOff} color={'brand'} />
      </Box>
    )
  } else {
    markup = (
      <Image
        boxSize={10}
        src={src}
        alt={alt}
        rounded="lg"
        loading="lazy"
        decoding="async"
        {...rest}
      />
    )
  }

  if (tooltip) {
    markup = (
      <Tooltip openDelay={0} content={tooltip}>
        {markup}
      </Tooltip>
    )
  }

  return markup
}
